module.exports = __webpack_public_path__ + "static/EPD-lamppost-sensor-data_inside-banner_tc-ce624ecdee085c3735d0d3885e4e8f53.jpg";